import script from "/app/components/paginator.vue?type=script";
import "/app/components/paginator.vue?type=style";
import { render } from "/app/components/paginator.vue?type=template";
script.render = render;
export default script;
